export class ClientPageRequest{

  clientId: string;
  pageNum: number;
  pageSize: number;
  recordId: number;
  searchValue: string;
  sortBy: string;
  sortDir: string;
}